import React from 'react';

import DeviceBackupContainer, {
  containerConfiguration,
} from '@totem/components/services/backup/deviceBackups/deviceBackupContainer';
import DeviceBackupTable from '@totem/components/services/backup/deviceBackups/deviceBackupTable';
import SummaryContainer from '@totem/components/services/backup/deviceBackups/SummaryContainer';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import DropDownFilters from '@totem/components/ui_components/reportSettings/dropDownFilters';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';

const DeviceBackups = () => {
  return (
    <ContentLayout landingPageName={'backups'}>
      <InputContainer
        filterConfig={containerConfiguration}
        componentKey="dashboard.backup"
        componentLabel="Backup Report"
        defaultSort={{ field: 'device.displayName', direction: 'ascend' }}
        useUrlParams
      >
        <DeviceBackupContainer>
          <IBCard isCovered>
            <SummaryContainer />
            <DropDownFilters
              keys={['systemType', 'building', 'region']}
              extra={''}
              showFilterChips
            />
            <DeviceBackupTable />
          </IBCard>
        </DeviceBackupContainer>
      </InputContainer>
    </ContentLayout>
  );
};

export default DeviceBackups;
